import { connect } from 'react-redux';
import {
  navigationProgress,
  navigationCompleted,
  navigationPending,
  navigationLoading,
  aislesLayout,
  currentStore,
  botMessages,
} from 'core/selectors';
import { getLayout } from 'core/slices/aisles';
import NavigationStatusModal from '../../../components/navigation/NavigationStatusModal';

const mapStateToProps = state => ({
  navigationProgress: navigationProgress(state),
  navigationCompleted: navigationCompleted(state),
  navigationPending: navigationPending(state),
  navigationLoading: navigationLoading(state),
  aislesLayout: aislesLayout(state),
  currentStore: currentStore(state),
  botMessages: botMessages(state),
});

export default connect(mapStateToProps, { getLayout })(NavigationStatusModal);
